import { SESSION_TIME_OUT_DELAY, relativeNow, createValueHistory, DISCARDED, mockable, buildUrl } from '@datadog/browser-core';
/**
 * We want to attach to an event:
 * - the url corresponding to its start
 * - the referrer corresponding to the previous view url (or document referrer for initial view)
 */
export var URL_CONTEXT_TIME_OUT_DELAY = SESSION_TIME_OUT_DELAY;
export function startUrlContexts(lifeCycle, hooks, locationChangeObservable) {
  var urlContextHistory = createValueHistory({
    expireDelay: URL_CONTEXT_TIME_OUT_DELAY
  });
  var previousViewUrl;
  lifeCycle.subscribe(1 /* LifeCycleEventType.BEFORE_VIEW_CREATED */, function (_ref) {
    var startClocks = _ref.startClocks,
      url = _ref.url;
    var locationHref = mockable(location).href;
    var viewUrl = url !== undefined ? buildUrl(url, locationHref).href : locationHref;
    urlContextHistory.add(buildUrlContext({
      url: viewUrl,
      referrer: !previousViewUrl ? document.referrer : previousViewUrl
    }), startClocks.relative);
    previousViewUrl = viewUrl;
  });
  lifeCycle.subscribe(6 /* LifeCycleEventType.AFTER_VIEW_ENDED */, function (_ref2) {
    var endClocks = _ref2.endClocks;
    urlContextHistory.closeActive(endClocks.relative);
  });
  var locationChangeSubscription = locationChangeObservable.subscribe(function (_ref3) {
    var newLocation = _ref3.newLocation;
    var current = urlContextHistory.find();
    if (current) {
      var changeTime = relativeNow();
      urlContextHistory.closeActive(changeTime);
      urlContextHistory.add(buildUrlContext({
        url: newLocation.href,
        referrer: current.referrer
      }), changeTime);
    }
  });
  function buildUrlContext(_ref4) {
    var url = _ref4.url,
      referrer = _ref4.referrer;
    return {
      url: url,
      referrer: referrer
    };
  }
  hooks.register(0 /* HookNames.Assemble */, function (_ref5) {
    var startTime = _ref5.startTime,
      eventType = _ref5.eventType;
    var urlContext = urlContextHistory.find(startTime);
    if (!urlContext) {
      return DISCARDED;
    }
    return {
      type: eventType,
      view: {
        url: urlContext.url,
        referrer: urlContext.referrer
      }
    };
  });
  return {
    findUrl: function findUrl(startTime) {
      return urlContextHistory.find(startTime);
    },
    stop: function stop() {
      locationChangeSubscription.unsubscribe();
      urlContextHistory.stop();
    }
  };
}